<template>
<div class="Page Home">
  <a-scene
    class="Scene"
    vr-mode-ui="enabled: true"
    antialias="true"
    :stats="$root.isDev"
    @enter-vr="$store.commit('app/SET_VR', true)"
    @exit-vr="$store.commit('app/SET_VR', false)"
    @renderstart="renderStarted = true"
  >
    <a-assets timeout="30000">
      <a-asset-item
        @loaded="loaded = true"
        id="terrain"
        :src="cdn(require('@/components/terrain/3d/scene.glb'))"
      />
    </a-assets>

    <a-entity ref="obelix" id="obelix" position="7.125 2.281 -6.461" />
    <a-entity ref="house" id="house" position="-38.135 4.286 -34.039" />

    <a-plane
      ref="observer"
      color="red"
      width=".5"
      height=".5"
      opacity=".2"
      material="shader: flat; side: double"
      scale="0 0 0"
      position="1.2 2 5.8"
    />

    <Camera ref="camera" />
    <Environment v-if="renderStarted" />

    <Captation
      v-for="captation in captations"
      :key="captation.name"
      :captation="captation"
    />
  </a-scene>
  <Top />
  <Bottom v-if="!vr"/>
  <About v-if="about"/>
  <Sniffer v-if="!$root.$agent.webgl" />
</div>
</template>

<script>
import 'aframe-environment-component'
import 'aframe-look-at-component'
import TweenMax from 'gsap'
import Settings from '@/config/Settings'

import Captation from '@/components/captation/Captation.vue'
import Camera from '@/components/camera/Camera'
import Environment from '@/components/environment/Environment'
import Top from '@/components/top/Top'
import Bottom from '@/components/bottom/Bottom'
import About from '@/components/about/About'
import Sniffer from '@/components/sniffer/Sniffer'

export default {
  name: 'Home',
  components: { Captation, Camera, Environment, Top, Bottom, About, Sniffer },
  data: () => ({
    loaded: false,
    renderStarted: false,
  }),
  watch: {
    vr() {
      if(!this.vr)
        document.querySelector('a-scene').renderer.setPixelRatio( window.devicePixelRatio )
    },
  },
  beforeDestroy() {
    _.each(["", "webkit", "moz", "ms"], prefix => document.removeEventListener(prefix + 'fullscreenchange', this.onFullScreen))
    window.removeEventListener('orientationchange', this.onOrientation)
  },
  mounted() {
    this.$scene = document.querySelector('a-scene')
    this.$renderer = this.$scene.renderer
    this.$renderer.sortObjects = true

    this.$renderer.gammaOutput = true
    this.$renderer.gammaInput = true

    _.each(["", "webkit", "moz", "ms"], prefix => document.addEventListener(prefix + 'fullscreenchange', this.onFullScreen))

    if(this.$root.$agent.mobile)
      window.addEventListener('orientationchange', this.onOrientation)
  },
  methods: {
    onFullScreen() {
      const fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement
      this.$store.commit('app/SET_FULLSCREEN', fullscreenElement ? true : false)
    },
    onOrientation() {
      this.$scene = document.querySelector('.Scene')
      for(let i = 100; i < 600; i += 100) {
        setTimeout(() => {
          this.$scene.resize()
          this.$store.commit('app/SET_ORIENTATION')
        }, i)
      }
    }
  }

}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Home
  height 100%
  width 100%
  overflow hidden

  .a-enter-vr-button
    display none

  .Scene
    width 100%
    height 100%
    position absolute
    z-index 9

    .a-canvas
      width 100% !important
      height 100% !important

</style>




// WEBPACK FOOTER //
// src/pages/home/Home.vue